jQuery(document).ready(function($) {
	const currency = '$';

	$('.calculator-block form').submit(function(e) {
		e.preventDefault();
		var $parent = $(this).parents('.calculator-block');
		var data = $(this).serialize();

  		$.ajax({
  			async: false,
	        url : '/wp-content/themes/fig/functions/features/calculator-api.php?' + data,
	        type: 'GET',
	        dataType: 'json',
	        success: function(data) {
	        	var output = '';
	        	$.each(data, function(key, value) {
	        		if(typeof value == 'object') {
	        			output = output + '<h3>' + key + '</h3>';
	        			$.each(value[0], function(key2, value2) {
	        				if($.isNumeric(value2)) {
	        					value2 = currency + value2.toFixed(2);
	        				}
	        				output = output + '<p><strong>' + key2 + ':</strong> ' + value2 + '</p>';
	        			});
	        		} else {
        				if($.isNumeric(value)) {
        					value = currency + value.toFixed(2);
        				}
	        			output = output + '<p><strong>' + key + ':</strong> ' + value + '</p>';
	        		}
	        	});
	        	
	        	output = output.replace(/([A-Z])/g, ' $1').trim();

	        	$('form', $parent).hide();
	        	$('.calculator-block__results', $parent).html(output);
	        },
	        error: function(data) {
	        	console.log(data);
	        },
        });
	});

});